<template>
  <div
    class="challenge-lesson-card bg-white rounded  box-shadow-primary flex flex-col"
  >
    <!-- Header -->
    <div class="challenge-lesson-card-header">
      <div
        class="h-3 rounded-b-none rounded"
        :style="{ backgroundColor: lesson.discipline.hex_color }"
      ></div>
      <h3
        class="text-center text-gray-500 font-light uppercase text-sm mt-2 mb-2"
      >
        {{ lesson.discipline.shortname }}
      </h3>
      <img
        :src="`/img/icons/disciplines/${lesson.discipline.id}.svg`"
        width="50px"
        alt=""
        class="mx-auto"
      />
    </div>
    <!-- Body -->
    <div class="challenge-lesson-card-body flex-1">
      <div class=" flex-1 text-center my-4 leading-snug">
        <h2 class="font-light leading-tight">
          {{ lesson.name }}
        </h2>
      </div>
    </div>
    <!-- Footer -->
    <div class="challenge-lesson-card-footer px-4 pb-2 ">
      <div
        class="text-green-400 text-right uppercase flex justify-end items-center"
        v-if="isCompleted"
      >
        <i class="material-icons text-green-400 text-sm mr-1 font-bold">
          check_circle_outline
        </i>
        <span class="text-xs font-bold">Completo</span>
      </div>
      <div
        class="text-yellow-500 text-right uppercase flex justify-end items-center"
        v-if="isStarted"
      >
        <i class="material-icons text-sm mr-2 text-yellow-500 font-bold">
          access_time
        </i>
        <span class="text-xs font-bold">Iniciado</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChallengeLessonCard",
  props: { challenge: Object, lesson: Object },
  data() {
    return {
      disciplines: {}
    };
  },
  computed: {
    isCompleted: function() {
      if (this.lesson) {
        return this.lesson.contents.every(content => {
          return content.completed_at;
        });
      }
      return false;
    },
    isStarted: function() {
      if (this.lesson) {
        return (
          this.lesson.contents.some(content => {
            return content.completed_at;
          }) && !this.isCompleted
        );
      }
      return false;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px;
}
.challenge-lesson-card {
  min-height: 180px;
}
</style>
